export default function HeroSection() {
  return (
    <header className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20light%20streaks%20in%20warm%20amber%20gold%20and%20deep%20copper%20terracotta%20tones%2C%20elegant%20dynamic%20blur%20effect%2C%20smooth%20gradient%20transitions%2C%20premium%20technology%20aesthetic%2C%20clean%20minimalist%20composition%2C%20soft%20glowing%20particles%2C%20no%20people%2C%20no%20text%2C%20dark%20rich%20warm%20background%20with%20bright%20highlighted%20flowing%20energy%20lines%2C%20abstract%20engineering%20vibe%2C%20cinematic%20lighting%2C%204K%20quality&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="Abstract technology backdrop with warm flowing energy lines"
        title="Siavash Media AB engineering backdrop"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white tracking-tight leading-none mb-8 md:mb-10">
          Siavash Media AB
        </h1>
        <p className="font-heading italic text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white/90 font-light mb-10 md:mb-14 leading-snug">
          Engineering the future of digital experiences
          <br className="hidden sm:block" />
          on the iOS platform
        </p>
        <p className="text-sm sm:text-base md:text-lg text-white/70 font-light max-w-2xl mx-auto leading-relaxed">
          A professional engineering team dedicated to designing and developing modern
          digital software solutions. We build scalable, maintainable, and high-performance
          systems with a strong focus on usability, stability, and long-term technical quality.
        </p>
      </div>
    </header>
  );
}